import React from 'react';

import Dropdown from "./ReactDropdown";

export default class DropdownAttitude extends Dropdown
{		
	
	// Entry properties
	//
	// mode : 'list' - Just act like a dropdown with each role itemised
	//        'filter' - act as a drop do	wn filter list, including an 'ALL' option
	
	static get defaultProps() 
	{
		var v =
			{
				mode: 'list',
				label: 'Select attitude',
				defaultValue: -1,
				containerClassName: 'input-group'
			} ;

		return v ;
	}
	
	constructor(props) 
	{
		super(props);
		
		this.keyCount = 1 ;

		let attitudeId = -1 ;

		if ( this.props.defaultValue != null )
		{
			// We have reduced the number of values from 2 to 4, so just translate them for now
			attitudeId = this.translateLegacyAttitude(this.props.defaultValue);
		}

    	// Create a state item here
		this.state = { dirty: false, valid: true, currentValue: attitudeId, items: null };
		
	}

	translateLegacyAttitude ( id )
	{
		let translatedValue = id ;

		if ( id == 1 )
		{
			translatedValue = 2 ;
		}
		else if ( id == 4 )
		{
			translatedValue = 3 ;
		}

		return translatedValue ;
	}

	UNSAFE_componentWillMount()
	{		
		// This is a callback to tell the parent our ID so it can talk to this contrao
		if ( this.props.parentRef != null )
		{
			this.props.parentRef ( this.props.id, this ) ;		
		}
		
		// Fetch the list of types to populste the dropdown
		this.getdata () ;
	}
	
	getdata( )
	{
			const addNA = this.props.includeNotApplicable === true ? [ { id: 5, desc: 'Not Applicable'}] : [] ;

		var attitude = [
		  {
			    id: 0,
			    desc: 'Please Select'
		  },
		  {
		    	id: '2',
		    	desc: 'Good'
		  },
		  {
			    id: '3',
			    desc: 'Improvement Needed'
		  },
			...addNA,
		];

		this.setState ( { items : attitude } ) ;
	}

    handleChange(e)
	{
		var index = e.target.selectedIndex;

		// Need to calculate the offset to read the actual Type Id from the correct place in the table
		// If it is a 'filter' then there is an extra entry in the listbox called 'ALL' which we need to account for
		
		var offset = 0 ;
		let itemid ;
		let itemtext ;

		if ( index > 0 )
		{
			itemid = this.state.items[index+offset].id;
			itemtext = this.state.items[index+offset].desc ;
		}
		else
		{
			itemid = 0 ;
			itemtext = "All" ;
		}

		this.sendChangeNotification() ;

		this.setState ( {dirty: true, currentValue: itemid } ) ;

		if ( this.props.callback != null )
		{
			this.props.callback ( itemid, itemtext ) ;		
		}
	}
	  
    getValue()
    {
    	return this.state.currentValue ;
    }

	/**
	 * Returns true if the input value complies with the validation rules supplied
	 *
	 * @param {string} param - The value of the string to be tested.
	 * @return {bool} true if the test passes.
	 */
	isValueValid( param )
	{
		if ( this.props.validation != null )
		{
			if ( this.props.validation.required == true )
			{
				if ( param == null || param == 0 || param == -1)
				{
					return false ;
				}
			}
			else
			{
				if ( param == null || param == 0 || param == -1 )
				{
					// If not required, and empty, it's OK
					return true ;
				}
			}
		}

		return true ;
	}

    optionList ()
    {
        var lineList=[];
        
        // This element renders from the list of user types returned by the getdata() ajax function above
    	var itemArray = this.state.items ;

    	if ( itemArray != null )
        {
        	var i = 0 ;
            var len = itemArray.length;
            var row = null ;
            var typeId = null ;
            var typeText = null ;
            
           for (i=0; i<len; ++i) 
            {
            	if (i in itemArray) 
            	{
            		row = itemArray[i];
            		
            		typeId = row.id ;
            		typeText = row.desc;
            		
            		lineList.push(React.createElement ( 'option', {key: this.keyCount++, name: typeId, value: typeId} , typeText));        			
            	}
            }
        }
        
        return lineList ;
    }
    
    dropdown_select ( id )
    {
    	return React.createElement ( 'select', {key: this.keyCount++, value: this.state.currentValue, className: 'form-control', id: id , tabIndex: this.props.tabIndex, onChange: this.handleChange.bind(this)}, this.optionList() ) ;
    }

    render() 
    {
    	this.keyCount = 0 ;

		if ( this.props.readOnly !== 'readonly' )
		{
			return React.createElement ( 'div', {key: this.keyCount++, className: this.props.containerClassName}, this.optionDropdown('list1')) ;
		}
		else
		{
			return React.createElement ( 'div', {key: this.keyCount++}, this.readOnlyField()) ;
		}
    }
};


